const Helpers = require('../helpers/_helpers.js');
const debounce = require('../helpers/debounce');
const $ = require('jquery');

/**
 * Navbar component.
 *
 * Usage:
 * Call Navigation.init() to initialize the navbar functionalities.
 *
 * Methods:
 *
 * init(): attaches eventlisteners to the $trigger
 */

let $searchTrigger;
let $searchTarget;

const duration = 800;
const customeasing = "customeasing";

const $navs = document.querySelectorAll('.nav-desktop .navbar.sub-nav, .nav-desktop .navbar.main-nav, .nav-mobile .nav-mobile-container'); // Used for offsetting against bottom of navbar
const getOffset = () => {
	// We can just get all heights, since clientHeight will be 0 for those whos breakpoint isn't applicable
	let offset = 0;
	$navs.forEach($nav => {
		offset += $nav.clientHeight;
	})
	return offset;
}

const paddles = () => {
	const $wrappers = document.querySelectorAll('.js-navbar-columns-with-paddles');
	if ($wrappers.length === 0) return;

	// Set visibility of paddles
	const setVisibility = ($paddles, setVisible) => {
		$paddles.forEach($paddle => {
			if (setVisible) {
				$paddle.removeAttribute('disabled');
			} else {
				$paddle.setAttribute('disabled', true);
			}
			$paddle.setAttribute('aria-hidden', setVisible);
		});
	};

	// Determine visibility of paddles based on columns' dimensions and scroll position
	const determineVisibility = ($columns, $paddles) => {
		const needsPaddles = $columns.clientWidth < $columns.scrollWidth;
		if (needsPaddles) {
			setVisibility([$paddles[0]], $columns.scrollLeft > 0);
			setVisibility(
				[$paddles[1]],
				$columns.scrollLeft < ($columns.scrollWidth - $columns.clientWidth - 1)
			);
		} else {
			setVisibility($paddles, false);
		}
	};

	$.easing[customeasing] =  function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	};

	$wrappers.forEach($wrapper => {
		const $paddles = $wrapper.querySelectorAll(
			'.navbar-dropdown-paddles .navbar-dropdown-paddle'
		);
		const $columns = $wrapper.querySelector('.navbar-dropdown-columns');

		// Handle click events on paddles
		$paddles.forEach($paddle => {
			const isLeft = $paddle.classList.contains('navbar-dropdown-paddle-left');
			$paddle.addEventListener('click', () => {
				$($columns).stop();
				const left = (isLeft ? -1 : 1) * $columns.clientWidth;
				// Custom duration: the smaller the width to bridge, the longer the duration, to make it feel not as instant
				const percentage = ($columns.scrollLeft + left + $columns.clientWidth) / $columns.scrollWidth;
				const dur = duration * (percentage < 1 ? 1 : 1.5);
				$($columns).animate({scrollLeft: $columns.scrollLeft + left}, dur, customeasing, () => {
					determineVisibility($columns, $paddles);
				});
			});
		});

		// Update paddle visibility on columns' scroll
		$columns.addEventListener('scroll', () => {
			determineVisibility($columns, $paddles);
		});

		// On resize, added/removed based on element being visible
		const onResize = () => {
			determineVisibility($columns, $paddles);
		};
		const debounced = debounce(onResize, 500);

		// Since these elements start out as display none, and can become display none again, which messes with clientWidth etc
		// check when elements become display block
		let observer = new IntersectionObserver((entries, observer) => { 
			entries.forEach(entry => {
				if (entry.intersectionRatio !=1) {
					window.removeEventListener('resize', debounced);
				} else {
					window.addEventListener('resize', debounced);
					determineVisibility($columns, $paddles);
				}
			});
		}, { threshold: 1 });
		observer.observe($columns);
	});
};

const toggleLookingGlass = on => {
	if (!$searchTrigger) return;
	$searchTrigger.classList.toggle('is-active', on);
	$searchTarget.classList.toggle('is-active', on);
	Helpers.mask.toggleFor('has-searchbar-open', on);
};

const lookingGlass = () => {
	$searchTrigger = document.querySelector('.js-looking-glass');
	if ($searchTrigger) {
		$searchTarget = document.querySelector(`#${$searchTrigger.dataset.target}`);
		$searchTrigger.addEventListener('click', e => {
			e.preventDefault();
			toggleLookingGlass(!$searchTarget.classList.contains('is-active'));
		});
	}
};

const minimumScrollFromTop = 100; // Shared by scroll listeners

/**
 * Show or hide the navigation bar on scroll
 */
const showOrHideNavigationBarOnScroll = () => {
	let lastScrollTop = 0;
	window.addEventListener('scroll', () => {
		const currentScroll = window.scrollY;
		if (currentScroll > minimumScrollFromTop && currentScroll > lastScrollTop) {
			document.body.classList.add('is-scrolling-down');
		} else {
			document.body.classList.remove('is-scrolling-down');
		}
		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
	}, false);
};

/**
 * navigation transparent on / off functionality.
 * when on the topm of the page may be transparent but when scroll down should be white
 */
const watchTransparentNav = () => {
	const $targets = document.querySelectorAll('.js-nav-transparent');
	if ($targets.length > 0) {
		const activeClass = 'is-at-top';
		window.addEventListener('scroll', ev => {
			$targets.forEach($target => {
				$target.classList.toggle(activeClass, window.scrollY < minimumScrollFromTop);
			});
		});
	}
};

const toggleMopbileNav = () => {
	const $btn = document.querySelector('.js-nav-btn-mobile');
	const $target = document.querySelector('.js-nav-content-mobile');
	if ($btn) {
		$btn.addEventListener('click', () => {
			$btn.classList.toggle('is-active');
			$target.classList.toggle('is-active');
			document.documentElement.classList.toggle('is-clipped');
		});
	}
};

const toggleMopbileSubnav = () => {
	const $triggers = document.querySelectorAll('.js-subnav-trigger');
	const $backBtns = document.querySelectorAll('.js-go-back-btn');
	if ($triggers.length > 0) {
		$triggers.forEach($triggerElement => {
			$triggerElement.addEventListener('click', () => {
				$triggerElement.nextElementSibling.classList.add('is-active');
			});
		});
	}
	if ($backBtns.length > 0) {
		$backBtns.forEach($btn => {
			$btn.addEventListener('click', () => {
				$btn.closest('.js-container').classList.remove('is-active');
			});
		});
	}
};

const init = () => {
	Helpers.mask.registerFor('has-navbar-open');
	lookingGlass();
	paddles();
	showOrHideNavigationBarOnScroll();
	watchTransparentNav();
	toggleMopbileNav();
	toggleMopbileSubnav();
};

module.exports = {
	init,
	getOffset,
	toggleLookingGlass
};
